import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';
import AdminPage from './components/AdminPage';
import { AuthProvider, useAuth } from './context/AuthContext';

function AppContent() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const [showAdmin, setShowAdmin] = useState(false);

  // Check URL hash for admin route
  useEffect(() => {
    const handleHashChange = () => {
      setShowAdmin(window.location.hash === '#/admin');
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage onLoginSuccess={login} />;
  }

  if (showAdmin) {
    return (
      <AdminPage
        onBack={() => {
          window.location.hash = '';
          setShowAdmin(false);
        }}
      />
    );
  }

  return <Dashboard onAdminClick={() => (window.location.hash = '#/admin')} />;
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
